module.exports = __webpack_public_path__ + "media/stop-6.0ac7b4eb.mp3";